import { FormElems } from 'components';
import { BUSINESS_SECTION_TYPE_MLE } from 'components/Onboarding/Mle/BusinessTab/contants';
import MyTooltip from 'components/Onboarding/Mle/BusinessTab/MyTooltip';
import { ERROR_FETCH } from 'components/Onboarding/Mle/mle.constants';
import { defaultOption, fetchFieldValue, fetchPinCodeDetails, FIELD_TYPES, isApproved, redClassRemarksCond, removeDuplicates, replaceSquareBraces } from 'components/Onboarding/Mle/mle.utils';
import TitleComponent from 'components/TitleComponent';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Field } from 'redux-form';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { nameValueOptions } from 'utils/helperMethods';

const Address = (props) => {
    const {
        fields,
        setIsUploading,
        setPinCodeDetails,
        actions,
        formName,
        pinCodeDetails,
        isViewMode,
        values,
        checkerRemarks,
        isEditMode,
        infoMsgs,
        isReEditFlow
    } = props;

    const [disablePinFields, setDisablePinFields] = useState(true);
    const [fieldEditable, setFieldEditable] = useState(true);

    useEffect(() => {
        if (pinCodeDetails.length > 0) {
            actions.change(formName, fields.state.name, pinCodeDetails[0].stateName);
            actions.change(formName, fields.district.name, pinCodeDetails[0].districtName);
        }
    }, [pinCodeDetails]);

    // case of ubo removal
    useEffect(() => {
        if (values?.uboDetails?.length) {
            setFieldEditable(true);
            setDisablePinFields(true);
        }
    }, [values?.uboDetails?.length]);

    const handlePinValue = async (pin) => {
        setIsUploading(true)
        try {
            // to check pin length and update state and district
            if (pin?.toString()?.length == 6) {
                let payload = {
                    sectionType: BUSINESS_SECTION_TYPE_MLE,
                    fieldType: FIELD_TYPES.pinCode,
                    fieldValue: pin
                }
                const pinData = await fetchPinCodeDetails(payload);
                setDisablePinFields(false);
                if (pinData.statusCode  != apiStatusCodes.SUCCESS2) {
                    setFieldEditable(true);
                } else {
                    setFieldEditable(false);
                }
                
                setPinCodeDetails(pinData?.basicSectionData?.pinCodeDetails || []);
            } else {
                actions.change(formName, fields.state.name, null);
                actions.change(formName, fields.district.name, null);
                setFieldEditable(false);
            }
        } catch(e) {
            setFieldEditable(true);
            toast.error(ERROR_FETCH);
        }
        setIsUploading(false);
    }

    let states = removeDuplicates(pinCodeDetails, 'stateName').map(item => item.stateName);
    let districts = pinCodeDetails.map(item => item.districtName);
    const pinInfoMsg = infoMsgs?.[replaceSquareBraces(fields.pin.name)] ?? '';
    const addressInfoMsg = (!pinInfoMsg) ? infoMsgs?.[replaceSquareBraces(fields.address.name)] : '';
    return (
        <>
            <div className="form-field">
                <TitleComponent 
                    field={fields.pin} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode} 
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.pin.name}
                />
                <Field
                    name={fields.pin.name}
                    type={fields.pin.type}
                    id={fields.pin.name}
                    component={FormElems.Input}
                    placeholder={fields.pin.label}
                    infoElement={pinInfoMsg}
                    onBlur={() => {}}
                    onChange={(pin) => {
                        handlePinValue(pin);
                        if (isEditMode) {
                            actions.change(formName, fields.address.name, '');
                        }
                    }}
                    disabled={isViewMode || isApproved(checkerRemarks, fields.pin.name, null, isEditMode)}
                />
            </div>
            <div className="form-field">
                <TitleComponent 
                    field={fields.district} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode} 
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.district.name}
                />
                {!fieldEditable && (
                    <Field
                        name={fields.district.name}
                        type={fields.district.type}
                        id={fields.district.name}
                        component={FormElems.Select}
                        labelField="name"
                        valueField="value"
                        // data={[]}
                        data={[...defaultOption, ...nameValueOptions(districts)]}
                        placeholder={fields.district.label}
                        disabled={isViewMode || disablePinFields || isApproved(checkerRemarks, fields.district.name, null, isEditMode)}
                    />
                )}
                {fieldEditable && (
                    <Field
                        name={fields.district.name}
                        type='text'
                        id={fields.district.name}
                        component={FormElems.Input}
                        placeholder={fields.district.label}
                        disabled={isViewMode || disablePinFields || isApproved(checkerRemarks, fields.district.name, null, isEditMode)}
                    />
                )}
            </div>
            <div className="form-field">
                <TitleComponent 
                    field={fields.state} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode} 
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.state.name}/>
                {!fieldEditable && (
                    <Field
                        name={fields.state.name}
                        type={fields.state.type}
                        id={fields.state.name}
                        component={FormElems.Select}
                        labelField="name"
                        valueField="value"
                        data={[...defaultOption, ...nameValueOptions(states)]}
                        placeholder={fields.state.label}
                        disabled={isViewMode || disablePinFields || isApproved(checkerRemarks, fields.state.name, null, isEditMode)}
                    />
                )}
                {fieldEditable && (
                    <Field
                        name={fields.state.name}
                        type='text'
                        id={fields.state.name}
                        component={FormElems.Input}
                        placeholder={fields.state.label}
                        disabled={isViewMode || disablePinFields || isApproved(checkerRemarks, fields.state.name, null, isEditMode)}
                    />
                )}
            </div>
            <div className="form-field">
                <TitleComponent 
                    field={fields.address} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode} 
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.address.name}/>
                <Field
                    name={fields.address.name}
                    type={fields.address.type}
                    id={fields.address.name}
                    component={FormElems.Input}
                    infoElement={addressInfoMsg}
                    placeholder={fields.address.label}
                    disabled={isViewMode || isApproved(checkerRemarks, fields.address.name, null, isEditMode)}
                />
            </div>
        </>
    );
};

export default Address;
